/**
 * The confirm screen's own strings.
 */

/**
 * APPROVED COPY. Shown when person-api refuses a confirmation as a duplicate identity (R15). It is
 * the literal `DuplicateIdentityRequestException.MESSAGE` in person-api
 * (`src/main/java/com/greengate/verifime/service/permission/request/DuplicateIdentityRequestException.java`
 * on `main`), approved by Charles on the person-api PR 2088 review (comment r4317908795). One
 * string serves both triggers. The source governs: change it there, then here.
 */
export const DUPLICATE_IDENTITY_MESSAGE =
  'This identity is already shared with the client, so a new request was not opened.';

/**
 * UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build.
 * Mirrors person-api's exception message (source governs). The draft says "client" like its approved
 * sibling; the vocabulary says customer-facing copy says "service provider": an open choice for the
 * build.
 * Shown when person-api refuses a confirmation or a grant because the customer holds a photo card
 * or ImmiCard and the organisation code has not opted into that type. One string serves both cards.
 */
export const HELD_DOCUMENT_TYPE_NOT_ACCEPTED_MESSAGE =
  'This client does not accept a photo card or ImmiCard, so the request was not confirmed.';

/**
 * UNAPPROVED DRAFT (verifime-adr#874): to be approved with the stakeholder in the running build.
 * The label of the next step the confirm screen offers below the held document type message. It
 * reuses the wording of the wizard's "Back to Home" button; the Home navigation item reads "Home".
 */
export const HELD_DOCUMENT_TYPE_BACK_TO_HOME_LABEL = 'Back to Home';
